var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hotspot-mobile",attrs:{"data-index":_vm.index}},[_c('a',{staticClass:"link d-block py-2 mb-2 px-4",on:{"click":_vm.onClick}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }